export default __webpack_public_path__ + "static/media/Helm of Heroic Soul.7bb23f41.jpg";